import { useEffect } from "react";

export default function useVersionCheck() {
  useEffect(() => {
    fetch("/Documents/react-version.txt")
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch version: ${response.status}`);
        }
        return response.text();
      })
      .then((version) => {
        const currentVersion = version.trim();
        const storedVersion = localStorage.getItem("app-version");

        console.log("🚀 New App version:", currentVersion);

        if (currentVersion && storedVersion && currentVersion !== storedVersion) {
          console.log("🔄 New build detected, refreshing...");
          window.location.reload(true);
        }

        if (currentVersion) {
          localStorage.setItem("app-version", currentVersion);
        }
      })
      .catch((err) => console.error("Error checking version:", err));
  }, []);
}
